import {tns} from 'tiny-slider/src/tiny-slider';
import {querySelector} from "app/lib/helperjs";

export const Testimonials = () => {
    if (querySelector('.testimonials-wrapper')) {
        tns({
            container: '.testimonials-wrapper',
            items: 1,
            responsive: {
                720: {
                    items: 2
                },
                980: {
                    items: 3
                }
            },
            speed: 3000,
            autoplay: true,
            touch: true,
            mouseDrag: true,
            navPosition: 'bottom',
            controlsText: ['<i class="fas fa-chevron-left"> </i>', '<i class="fas fa-chevron-right"> </i>']
        });
    }
};
